/**
 * Matter Types Service - Type Definitions
 */

/**
 * All available matter type slugs.
 *
 * **A mirror of the backend `MatterTypeSlug` enum, pinned by
 * `__tests__/matter-type-capabilities-registry.test.ts`.** That guard caught
 * `BUSINESS` missing here (VALE-447): the backend had superseded
 * `sale-of-business` / `purchase-of-business` with a single active `business`
 * type, and this copy still listed only the two deprecated ones — so a real
 * `business` matter matched no member of the enum every consumer keys off.
 * Nothing failed; it just fell through every lookup. Add and remove members
 * here in the same commit as the backend.
 */
export enum MatterTypeSlug {
  ESTATE_ADMINISTRATION = 'estate-administration',
  ESTATE_PLANNING = 'estate-planning',
  ESTATE_DISPUTE = 'estate-dispute',
  ESTATE_ADVICE = 'estate-advice',
  NOTICE_OF_DEATH = 'notice-of-death',
  ADVICE_GENERAL_ADVICE = 'advice-general-advice',
  LITIGATION = 'litigation',
  CONVEYANCING_SALE = 'conveyancing-sale',
  CONVEYANCING_PURCHASE = 'conveyancing-purchase',
  CONVEYANCING_TRANSFER_DISCHARGE = 'conveyancing-transfer-discharge',
  CONVEYANCING_LEASE = 'conveyancing-lease',
  CONVEYANCING_OTHER = 'conveyancing-other',
  RETIREMENT_VILLAGE_CONTRACT = 'retirement-village-contract',
  CRIMINAL_LAW = 'criminal-law',
  BUSINESS = 'business',
  /** @deprecated superseded by `BUSINESS`; kept because historical matters carry it. */
  SALE_OF_BUSINESS = 'sale-of-business',
  /** @deprecated superseded by `BUSINESS`; kept because historical matters carry it. */
  PURCHASE_OF_BUSINESS = 'purchase-of-business',
  COMMERCIAL_LAW_GENERAL = 'commercial-law-general',
  BUSINESS_LAW = 'business-law',
  FAMILY_LAW = 'family-law',
  OTHER = 'other'
}

/**
 * Matter type from backend
 */
export interface MatterType {
  label: string;
  slug: string;
}
